import { DateTime } from "luxon";
import { NurseFullRoleShort } from "../../../utils/models";
import { getEmploymentTypeDisplayName } from "../../../utils/utilFunctions";
import { CSV_HEADERS } from "../constants";
import type { ScheduleReportShift } from "../types";

export const useExportToExcel = () => {
	const exportToExcel = (entries: ScheduleReportShift[]) => {
		if (!entries.length) return;

		const csvContent = [
			CSV_HEADERS.join(","),
			...entries.map((entry, index) =>
				[
					index + 1,
					`"${entry.nurseName}"`,
					`"${NurseFullRoleShort[entry.role as keyof typeof NurseFullRoleShort] || entry.role}"`,
					`"${getEmploymentTypeDisplayName(entry.employmentType)}"`,
					`"${entry.startTime.toFormat("MMM D, yyyy HH:mm")}"`,
					`"${entry.endTime.toFormat("MMM D, yyyy HH:mm")}"`,
					`"${entry.location || ""}"`,
					`"${entry.agencyName || ""}"`,
					`"${entry.charge ? "Yes" : "No"}"`,
				].join(","),
			),
		].join("\n");

		const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
		const link = document.createElement("a");
		const url = URL.createObjectURL(blob);
		link.setAttribute("href", url);
		link.setAttribute("download", `schedule-${DateTime.now().toFormat("yyyy-MM-dd")}.csv`);
		link.style.visibility = "hidden";
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	return { exportToExcel };
};
